// import { TableColumnsType } from "antd";
// import _ from "lodash";

// import { ICandidateDetails, IPositionDetails, Stage } from "@types";

// export const getColumns = ({
//   handleRowClick,
//   currentTab
// }: {
//   handleRowClick: (id: number, stage: Stage) => void;
//   currentTab: string;   // 👈 yahan add kar do
// }): TableColumnsType<any> => [
//   {
//     title: "candidate name",
//     dataIndex: "offer_candidate_detail",
//     key: "name",
//     width: 200,
//     render: (offer_candidate_detail: ICandidateDetails) =>
//       offer_candidate_detail?.candidate_name,
//   },
//   // {
//   //   title: "Stage",
//   //   dataIndex: "stage",
//   //   key: "title",
//   //   width: 200,
//   //   render: (stage: string) => stage,
//   // },
//   {
//     title: "Placement Date",
//     dataIndex: "placement date",
//     key: "title",
//     width: 200,
//     render: (stage: string) => stage,
//   },
//   {
//     title: "Job title",
//     dataIndex: "offer_position_detail",
//     key: "title",
//     width: 200,
//     render: (offer_position_detail: IPositionDetails) =>
//       offer_position_detail?.job_title,
//   },
//   {
//     title: "business unit",
//     dataIndex: "offer_position_detail",
//     key: "business_unit",
//     width: 250,
//     render: (offer_position_detail: IPositionDetails) =>
//       offer_position_detail?.business_unit?.name,
//   },
//   {
//     title: "region",
//     dataIndex: "offer_position_detail",
//     key: "region",
//     width: 200,
//     render: (offer_position_detail: IPositionDetails) =>
//       offer_position_detail?.region?.name,
//   },
//   {
//     title: "country",
//     dataIndex: "offer_position_detail",
//     key: "id",
//     width: 200,
//     render: (offer_position_detail: IPositionDetails) =>
//       offer_position_detail?.country?.name,
//   },
//   {
//     title: "status",
//     dataIndex: "status",
//     key: "id",
//     width: 200,
//     render: (status: string) => _.capitalize(status),
//   },

//   {
//     title: "Action",
//     key: "id",
//     width: 160,
//     fixed: "right",
//     render: offer => (
//       <>
//         <div
//           onClick={() => handleRowClick(offer?.id, offer?.stage)}
//           className="table__action__btn table__action__btn--client"
//         >
//           View
//         </div>
//       </>
//     ),
//   },
// ];

import { TableColumnsType } from "antd";
import _ from "lodash";
import { ICandidateDetails, IPositionDetails, Stage } from "@types";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";

export const getColumns = ({
  handleRowClick,
  currentTab,
  handleEditClick, // 👈 new callback for edit
  handleDeleteClick, // 👈 new callback for edit
}: {
  handleRowClick: (id: number, stage: Stage) => void;
  currentTab: string;
  handleEditClick?: (id: number, stage: Stage) => void;
  handleDeleteClick?: (id: number, stage: Stage) => void;
}): TableColumnsType<any> => {
  let columns: TableColumnsType<any> = [
    {
      title: "candidate name",
      dataIndex: "candidate_name",
      key: "name",
      width: 200,
      render: (candidate_name?: string) =>
        candidate_name,
      sorter: true,
    },
    {
      title: "Placement Date",
      dataIndex: "display_date",
      key: "placement_date",
      width: 200,
      render: (placement_date: string) => placement_date,
      sorter: true,
    },
    {
      title: "Job title",
      dataIndex: "job_title",
      key: "job_title",
      width: 200,
      render: (job_title?: string) =>
        job_title,
      sorter:true,
    },
    {
      title: "business unit",
      dataIndex: "business_unit",
      key: "business_unit",
      width: 250,
      render: (business_unit: string) =>
        business_unit,
      sorter:true,
    },
    {
      title: "region",
      dataIndex: "region",
      key: "region",
      width: 200,
      render: (region: string) =>
        region,
      sorter:true,
    },
    {
      title: "country",
      dataIndex: "country",
      key: "country",
      width: 200,
      render: (country: string) =>
        country,
      sorter:true,
    },
    {
      title: "status",
      dataIndex: "status",
      key: "status",
      width: 200,
      render: (status: string) => _.capitalize(status),
      sorter:true,
    },
    {
      title: "Action",
      key: "actions",
      width: 160,
      fixed: "right",
      render: offer => (
        <div className="flex gap-3">
          <div
            onClick={() => handleRowClick(offer?.id, offer?.stage)}
            className="table__action__btn table__action__btn--client"
          >
            View
          </div>

          {/* 👇 Only show Edit button in Active tab if can_be_revised */}
          {currentTab === "1" &&
            offer?.can_be_revised &&
            checkPermission(permissions.UPDATE_OFFER) && (
              <div
                onClick={() => handleEditClick?.(offer?.id, offer?.stage)}
                className="table__action__btn table__action__btn--client"
              >
                Edit
              </div>
            )}

          {currentTab === "3" && checkPermission(permissions.DELETE_OFFER) && (
            <div
              onClick={() => handleDeleteClick?.(offer?.id, offer?.stage)}
              className="table__action__btn table__action__btn--client"
            >
              Delete
            </div>
          )}
        </div>
      ),
    },
  ];

  // 👇 Replace second column instead of mutating
  // if (currentTab === "1") {
  //   columns = [
  //     columns[0],
  //     {
  //       title: "Date",
  //       dataIndex: "display_date",
  //       key: "offer_date",
  //       width: 200,
  //       render: (offer_date: string) => {
  //         if (!offer_date) return "-";

  //         const date = new Date(offer_date);

  //         // Custom month names (always 3 letters)
  //         const months = [
  //           "Jan",
  //           "Feb",
  //           "Mar",
  //           "Apr",
  //           "May",
  //           "Jun",
  //           "Jul",
  //           "Aug",
  //           "Sep",
  //           "Oct",
  //           "Nov",
  //           "Dec",
  //         ];

  //         const day = String(date.getDate()).padStart(2, "0");
  //         const month = months[date.getMonth()];
  //         const year = date.getFullYear();

  //         return `${day} ${month} ${year}`; // e.g. "01 Sep 2025"
  //       },
  //     },
  //     ...columns.slice(2),
  //   ];
  // }
  if (currentTab === "1") {
    columns = [
      {
        title: "Offer ID",
        dataIndex: "version_code",
        key: "version_code",
        width: 150,
        render: (version_code: string) => version_code || "-",
        sorter:true,
      },
      columns[0], // Candidate Name
      {
        title: "Date",
        dataIndex: "display_date",
        key: "offer_date",
        width: 200,
        render: (offer_date: string) => {
          if (!offer_date) return "-";

          const date = new Date(offer_date);
          const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const day = String(date.getDate()).padStart(2, "0");
          const month = months[date.getMonth()];
          const year = date.getFullYear();

          return `${day} ${month} ${year}`;
        },
        sorter:true,
      },
      ...columns.slice(2),
    ];
  }

  if (currentTab === "2") {
    columns = [
      // temporary khurram
      {
        title: "Offer ID",
        dataIndex: "version_code",
        key: "version_code",
        width: 150,
        render: (version_code: string) => version_code || "-",
        sorter:true,
      },
      columns[0],
      {
        title: "Date",
        dataIndex: "display_date",
        key: "offer_date",
        width: 200,
        render: (offer_date: string) => {
          if (!offer_date) return "-";

          const date = new Date(offer_date);

          // Custom month names (always 3 letters)
          const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];

          const day = String(date.getDate()).padStart(2, "0");
          const month = months[date.getMonth()];
          const year = date.getFullYear();

          return `${day} ${month} ${year}`; // e.g. "01 Sep 2025"
        },
        sorter:true,
      },
      ...columns.slice(2),
    ];
  }

  if (currentTab === "3") {
    columns = [
      columns[0],
      {
        title: "Date",
        dataIndex: "display_date",
        key: "offer_date",
        width: 200,
        render: (offer_date: string) => {
          if (!offer_date) return "-";

          const date = new Date(offer_date);

          // Custom month names (always 3 letters)
          const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];

          const day = String(date.getDate()).padStart(2, "0");
          const month = months[date.getMonth()];
          const year = date.getFullYear();

          return `${day} ${month} ${year}`; // e.g. "01 Sep 2025"
        },
        sorter:true,
      },
      ...columns.slice(2),
    ];
  }

  return columns;
};
